import { color } from './tokens/color.js';
import { font } from './tokens/font.js';
import { globals } from './tokens/globals.js';
import { light } from './tokens/palette.js';
import { radius } from './tokens/radius.js';
import { shadow } from './tokens/shadow.js';
import { spacing } from './tokens/spacing.js';
export const lightTheme = {
    radius,
    font,
    spacing,
    palette: light,
    shadow,
    globals,
    // ! need to deprecate
    color,
};
